<template>
  <div class="recover-password">
    <div class="recover-password__container">
      <div class="recover-password__brand">
        <img class="tingg-brand-logo" src="https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png" height="64" alt="Tingg"/>
      </div>

      <div class="recover-password__card">
        <div id="recover-password-error" v-show="showError" class="help-text help-text--error mb-4"
             style="display: none;">
          We were unable to recover your password. <br> Please try again later
        </div>

        <h3 class="recover-password__card-title">
          Recover Password
        </h3>

        <form @submit.prevent="recoverPassword" novalidate>
          <div :class="{'form-group': true, 'has-error': errors.has('email') }">
            <label class="mula-form-group__label control-label" for="email">Email</label>
            <input v-validate="'required|email'"
                   class="mula-form-group__input form-control"
                   id="email"
                   name="email"
                   type="email"
                   autocomplete="email"
                   v-model="email"
            >
            <span v-show="errors.has('email')" class="help is-danger">
              Your email is required
            </span>
          </div>

          <button type="submit" class="mula-btn tingg-primary-button">Recover</button>
        </form>
        <div class="recover-password__optional-cta">
          <span>Remember your password?</span>
          <a class="tingg-anchors" href="#" @click.prevent="goTo('/login')">Login</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Auth from '@/api/services/auth.js'

  const logInfo = !!(process.env.NODE_ENV !== 'production')

  export default {
    data () {
      return {
        email: '',
        showError: false
      }
    },

    methods: {
      recoverPassword () {
        // Reset the error alert
        this.showError = false
        // Check that all the user is expected to
        // fill in is provided
        this.$validator.validateAll()
          .then(result => {
            logInfo && console.log('Did the request to reset password pass validation?', result)

            if (result) {
              this.$btn.disable('.mula-btn')
              // Attempt to request for a password reset
              Auth.requestPasswordReset({email: this.email})
                .then(response => {
                  logInfo && console.log('The request to reset the password was successful', response)
                  this.$snackbar.open({
                    message: 'A reset password email has been successfully sent',
                    type: 'is-success',
                    position: 'is-bottom',
                    queue: false
                  })
                  this.$btn.enable('.mula-btn')
                })
                .catch(response => {
                  logInfo && console.log('The reset password request failed', response)
                  this.showError = true
                  this.$btn.enable('.mula-btn')
                })
            }
          })
          .catch(reason => {
            logInfo && console.log('Request password reset validation encountered an error', reason)
          })
      }
    },
    name: 'RecoverPassword'
  }
</script>

<style lang="scss">
  @import "../styles/theme";

  .recover-password {
    width: 100%;
    height: 100vh;

    display: flex;
    align-items: start;
    justify-content: center;

    background-image: linear-gradient(to bottom right, $tingg-primary-red, $tingg-purple);
  }

  .recover-password__container {
    @include make-col-ready();

    @include media-breakpoint-down(xl) {
      @include make-col(4);
    }

    @include media-breakpoint-down(md) {
      @include make-col(8);
    }

    @include media-breakpoint-down(sm) {
      @include make-col(10);
    }

    @include media-breakpoint-down(xs) {
      @include make-col(12);
    }

    height: 75%;

    margin-top: 2.5rem;
  }

  .recover-password__card {
    width: 100%;
    border-radius: 2px;
    padding: 1.5rem 3rem;
    background-color: $background-white;
  }

  .recover-password__card-title {
    width: 100%;
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .recover-password__brand {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 2.5rem;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/RecoverPassword.vue